import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

const getWeightUomAPI = () => {
  return axiosInstance.request({
    url: `${API.POV}/GetWeightUnitOfMeasure`,
    method: 'get',
  });
};

export type WeightUomResponse = {
  text: string;
  value: string;
}[];

export const fetchWeightUomList = async (): Promise<WeightUomResponse> => {
  const response: AxiosResponse<WeightUomResponse> = await getWeightUomAPI();
  return response.data;
};
